import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface InlineCTAProps {
  onSubmit: (plz: string) => void;
  heading?: string;
  subheading?: string;
  variant?: 'light' | 'dark';
}
export function InlineCTA({
  onSubmit,
  heading = 'Kostenlos Angebote erhalten und bis zu 40% sparen',
  subheading,
  variant = 'light'
}: InlineCTAProps) {
  const [plz, setPlz] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^\d{4}$/.test(plz)) {
      setError('Bitte geben Sie eine gültige 4-stellige Postleitzahl ein');
      return;
    }
    setError('');
    onSubmit(plz);
  };
  const isDark = variant === 'dark';
  return <section className={`py-12 sm:py-20 ${isDark ? 'bg-ofri-blue' : 'bg-gray-50'}`} data-id="element-34">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-35">
        <h2 className={`text-2xl sm:text-4xl font-bold tracking-tight ${isDark ? 'text-white' : 'text-gray-900'} ${subheading ? 'mb-3' : 'mb-8 sm:mb-10'}`} data-id="element-36">
          {heading}
        </h2>

        {subheading && <p className={`text-base sm:text-lg mb-8 sm:mb-10 ${isDark ? 'text-ofri-blue-light' : 'text-gray-600'}`} data-id="element-37">
            {subheading}
          </p>}

        <form onSubmit={handleSubmit} className="max-w-xl mx-auto" data-id="element-38">
          <div className="flex flex-col sm:flex-row gap-2 p-2 rounded-xl bg-white shadow-lg" data-id="element-39">
            <input type="text" inputMode="numeric" maxLength={4} value={plz} onChange={e => setPlz(e.target.value.replace(/\D/g, ''))} placeholder="Ihre Postleitzahl" className="flex-1 px-4 py-3 text-lg text-gray-900 placeholder-gray-400 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-ofri-blue focus:ring-2 focus:ring-ofri-blue/30 transition-colors" aria-label="Postleitzahl" data-id="element-40" />
            <button type="submit" className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-41">
              Offerten erhalten
              <ArrowRightIcon className="w-5 h-5" data-id="element-42" />
            </button>
          </div>
          {error && <p className={`mt-3 text-sm ${isDark ? 'text-red-100' : 'text-red-600'}`} data-id="element-43">
              {error}
            </p>}
          {isDark && <p className="mt-4 text-sm text-ofri-blue-light" data-id="element-44">
              Kostenlos · Unverbindlich · In 2 Minuten
            </p>}
        </form>
      </div>
    </section>;
}